<template>
  <div>
    <DashboardHeader title="Fees Spreadsheet">
      <SnackBar :text="snackbarText" :colour="snackbarColor" :model="snackbarModel"></SnackBar>
        <v-card>
        <v-layout row wrap class="mt-4" style="margin:0px">
          
            <v-row>
                
                <v-col cols="3">
                    <SelectClassComponent class="mt-0 mx-2" v-if="isAdmin" @selected-class="setSelectedClass"></SelectClassComponent>
                </v-col>
                <v-col cols="3" >
                    <v-card class="mx-2 mt-0" v-if="isStaff" shaped elevation="12" max-width="344" outlined>
                        <v-list-item three-line>
                    <DatePickerWithMenu class="mt-0 mx-2" v-if="showDate && isAdmin" @date-selected="getSelectedDate" label="Filter By Date"></DatePickerWithMenu>
                    </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="3">
                     <v-card class="mx-2 mt-0" v-if="isStaff" shaped elevation="12" max-width="344" outlined>
                        <v-list-item three-line>
                        <v-autocomplete
                            prepend-inner-icon="search"
                            v-model="selectedStudentSid"
                            :items="studentsIDData"
                            solo-inverted
                            flat
                            hide-details
                            label="Get Student Fee Record"
                            @change="getStudentFeeRecordAllYears()"
                        ></v-autocomplete>
                        </v-list-item>
                    </v-card>
                </v-col>
                 <!-- <v-col cols="9">
                     
                <span>
              <v-btn
                small
                rounded
                :color="getThemeColor"
                dark
                class="mx-4 mt-2"
                v-if="students.length > 0 && isAdmin"
                @click="openViewStatementDialog()"
              >
                <v-icon left>mdi-receipt</v-icon>Statements
              </v-btn>
            </span>
            <span>
              <v-btn
                small
                rounded
                :color="getThemeColor"
                dark
                class="mx-4 mt-2"
                v-if="students.length > 0 && isAdmin"
                @click="openBulkSMSDialog()"
              >
                <v-icon left>mdi-comment</v-icon>Bulk SMS
              </v-btn>
            </span>
            <v-btn
              v-if="students.length > 0 && isStaff"
              @click="exportMarksList()"
              small
              rounded
              color="green"
              dark
              class="mx-4 mt-2"
            >
              <v-icon left>mdi-office</v-icon>Export List
            </v-btn>
            <span v-if="students.length > 0">
              <v-btn
                v-if="isAdmin"
                small
                rounded
                :color="getThemeColor"
                dark
                class="mx-4 mt-2"
                @click="openApplyFeeDialog()"
              >
                <v-icon left>mdi-account</v-icon>Apply Fee ID
              </v-btn>
              <v-btn
                small
                rounded
                color="purple"
                dark
                class="mx-4 mt-2"
                v-if="isAdmin"
                @click="openBillStudentsDialog()"
              >
                <v-icon left>mdi-cash-plus</v-icon>Bill Students
              </v-btn>
              <v-btn
                v-if="isManager"
                @click="openBlockReportDialog()"
                small
                rounded
                color="error"
                dark
                class="mx-4 mt-2"
              >
                <v-icon left>mdi-book-lock</v-icon>Block Reports
              </v-btn>
              <v-btn
                v-if="isAdmin"
                @click="openCaptureMarksDialog()"
                small
                rounded
                color="blue-grey darken-4"
                dark
                class="mx-4 mt-2"
              >
                <v-icon left>mdi-account-multiple-check</v-icon>Marks & Schedule
              </v-btn>
              <v-btn
                v-if="isAdmin"
                @click="openAcademicReportDialog()"
                small
                rounded
                color="primary"
                dark
                class="mx-4 mt-2"
              >
                <v-icon left>mdi-book-education</v-icon>Academic Reports
              </v-btn>
              <v-btn
                v-if="isAdmin"
                @click="openPromoteStudentsDialog()"
                small
                rounded
                color="warning"
                dark
                class="mx-4 mt-2"
              >
                <v-icon left>mdi-check-decagram</v-icon>Promotions
              </v-btn>

              <v-btn
                v-if="isAdmin"
                @click="openBulkDeleteDialog()"
                small
                rounded
                color="red"
                dark
                class="mx-4 mt-2"
              >
                <v-icon left>mdi-delete</v-icon>Bulk Delete
              </v-btn>
            </span>
            
            </v-col> -->
            </v-row>
          
              
            <v-row>
              <v-switch
                :disabled="students.length < 1"
                v-model="selectAll"
                label="Select All"
                class="ml-8 mt-4"
                @change="selectAllStudents()"
              ></v-switch>
              <v-spacer></v-spacer>
              <v-text-field
                class="mt-0 mx-6"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="display:inline"
              ></v-text-field>
            </v-row>
            
            <v-data-table v-if="showStudentFeeRecordAllYears" :headers="studentFeeRecordByYearsHeaders" :items="studentFeeRecordByYears" :search="search">

            </v-data-table>
            <v-data-table :headers="headers" :items="students" :search="search" v-else>
              <template v-slot:item.profile="{item}">
                <v-icon :color="getThemeColor" @click="viewProfile(item)">mdi-account-circle</v-icon>
                <v-icon color="teal accent-3" v-if="isCarded(item.sid)">mdi-account-badge-horizontal</v-icon>
                <v-icon color="red" v-if="isReportBlocked(item.sid)">mdi-book-lock</v-icon>
              </template>
              <template v-slot:item.lname="{item}">
                <v-text-field @change="updateField(item.id,'lname')" v-model="item.lname"></v-text-field>
              </template>
              <template v-slot:item.fname="{item}">
                <v-text-field @change="updateField(item.id,'fname')" v-model="item.fname"></v-text-field>
              </template>

              <template v-slot:item.fid="{item}">
                <v-text-field @change="updateField(item.id,'fid')" v-model="item.fid"></v-text-field>
              </template>
              <template v-slot:item.tel="{item}">
                <v-text-field @change="updateField(item.id,'tel')" v-model="item.tel"></v-text-field>
              </template>
              <template v-slot:item.dob="{item}">
                <v-text-field @change="updateField(item.id,'dob')" v-model="item.dob"></v-text-field>
              </template>
              <template v-slot:item.number_of_days_absent="{item}">
                <v-text-field
                  @change="updateField(item.id,'number_of_days_absent')"
                  v-model="item.number_of_days_absent"
                ></v-text-field>
              </template>
            </v-data-table>
            </v-layout>
          </v-card>
        
      
      <v-dialog v-model="dialog" width="600" persistent>
        <v-card v-if="applyFee">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Apply Fee ID to Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>
          <v-autocomplete
            label="Select Fee ID to Apply"
            class="mx-10"
            :items="feeIDs"
            v-model="selectedFeeID"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="applyFeeIDNow()">Apply Now</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="promoteStudents">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Promotions For Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>
          <SelectClassComponent
            :label="'Select Class Promoted To'"
            class="my-6 mx-10"
            @selected-class="getClassPromotedTo"
          ></SelectClassComponent>
          <v-text-field label="Emis Number" class="mx-10" v-model="schoolEmis"></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="promoteStudentsNow()">Promote Now</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="academicReport">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >View Report For Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>

          <div class="mx-10 mt-4">
            <p>Source of Marks: {{ reportSource || 'Select The Source of The Marks' }}</p>
            <v-radio-group v-model="reportSource" mandatory>
              <v-radio label="Marks Entered Directly On BitsEMS" value="BitsEMS"></v-radio>
              <v-radio label="Marks Exported From SASAMS" value="SASAMS"></v-radio>
            </v-radio-group>
          </div>

          <v-autocomplete
            label="Select Report Term"
            class="mx-10"
            :items="reportTerms"
            v-model="selectedReportTerm"
          ></v-autocomplete>
          <v-autocomplete
            label="Select Report Year"
            class="mx-10"
            :items="reportYears"
            v-model="reportYear"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="viewAcademicReportsNow()">View Now</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="captureMarks">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Enter Marks Or View Schedule</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>
          <v-autocomplete
            label="Select Report Term"
            class="mx-10"
            :items="reportTerms"
            v-model="selectedReportTerm"
            @change="setOrGetTerm()"
          ></v-autocomplete>
          <v-autocomplete
            v-if="dsrop != null"
            label="Select Report Year"
            class="mx-10"
            :items="reportYears"
            v-model="reportYear"
            @change="setOrGetTerm()"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="markScheduleNow()">Continue</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="billStudents">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Bill Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>
          <v-text-field
            class="mx-6"
            :label="'Amount in '+getCurrency"
            :rules="nameRules"
            v-model="edAmount"
          ></v-text-field>
          <v-select
            class="mx-6"
            :rules="nameRules"
            v-model="edDescription"
            item-text="name"
            item-value="id"
            :items="categories"
            label="Description"
          ></v-select>
          <DatePickerWithMenu @date-selected="getSelectedDate"></DatePickerWithMenu>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="billStudentsNow()">Bill Now</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="blockReport">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Block Reports for Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>
          <v-autocomplete
            :rules="nameRules"
            label="Select Term"
            class="mx-10"
            :items="terms"
            v-model="selectedTerm"
          ></v-autocomplete>
          <v-textarea
            :rules="nameRules"
            label="Give Reason Or Comment"
            class="mx-10"
            v-model="blockReportReason"
          ></v-textarea>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="error" dark @click="blockReportNow()">Block Now</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="viewStatement">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >View Statements for Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Students Selected: {{selectedStudents.length}}</v-card-title>

          <v-row class="mx-10">
            <h5>Pick A Date For The Statements</h5>
            <v-date-picker v-model="datePicker"></v-date-picker>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="primary" dark @click="viewStudentsStatements()">View Now</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="bulkSMS">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Send Bulk SMS To Parents/Guardians Of Selected Students</v-card-title>

          <v-card-title class="mt-6 mx-4">Number of Messages Left: {{messageCredit}}</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Selected Students: {{selectedStudents.length}}</v-card-title>
          <v-textarea
            :rules="nameRules"
            label="Message Body"
            class="mx-10"
            v-model="bulkSMSBody"
            v-if="hasCredits"
          ></v-textarea>
          <v-alert v-else class="mx-6 mt-6" color="red" dark rounded="pill">
            <h6>Insufficient Credits : {{messageCredit}} Messages Left</h6>
            <h6>Call or WhatsApp Kenneth on 076 243 9441</h6>
            <h6>To Organize Credits</h6>
          </v-alert>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn
              rounded
              color="teal"
              dark
              @click="sendBulkSMSNow()"
              v-if="hasCredits"
            >Send Bulk SMS Now</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="bulkDelete">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2"
          >Delete Selected Students</v-card-title>
          <v-card-title class="mt-6 mx-4">Number of Selected Students: {{selectedStudents.length}}</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="error" dark @click="deleteBulkNow()">Delete Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import SelectClassComponent from "@/components/GeneralComponents/SelectClassComponent.vue";
import SnackBar from "@/components/myLibrary/SnackBar.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import XLSX from "xlsx";

export default {
  components: {
    DashboardHeader,
    SelectClassComponent,
    SnackBar,
    DatePickerWithMenu
  },
  computed: {
    hasCredits() {
      return this.messageCredit >= this.selectedStudents.length;
    },
    getSelectedClass() {
      return this.$store.getters.getSelectedClass;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getBulkSMSTokenId() {
      return this.$store.getters.getBulkSMSTokenId;
    },
    getBulkSMSTokenSecret() {
      return this.$store.getters.getBulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth() {
      return this.$store.getters.getBulkSMSBasicAuth;
    }
  },
  mounted() {
    this.schoolEmis = this.getUserSchool.emis;
    this.$store.commit("setLoader", true);
    this.setSelectedClass(this.getSelectedClass);
    this.getCardedStudents();
    this.getReportBlocked();

    // axios.getData("/auth/get-fee-ids", this.getAccessToken).then(feeIDs => {
    //   this.$store.commit("setLoader", false);
    //   feeIDs.forEach(fid => {
    //     const feeAmount = axios.formatMoney(
    //       Number(fid.deposit) + Number(fid.monthly) * Number(fid.months)
    //     );
    //     this.feeIDs.push({
    //       text:
    //         fid.fid + " [ Amount: " + this.getCurrency + " " + feeAmount + " ]",
    //       value: fid.fid
    //     });
    //   });
    // });
  },
  data: () => ({
    cardedStudents: [],
    blockedReportStudents: [],
    studentID: null,
    bulkSMSTokenId: "96C2A187620B41FAB3B31E0804F5EA06-01-2",
    bulkSMSTokenSecret: "mCQEABCuSZvZ106I9AKQR4hDAQjOQ",
    bulkSMSBasicAuth:
      "Authorization: Basic OTZDMkExODc2MjBCNDFGQUIzQjMxRTA4MDRGNUVBMDYtMDEtMjptQ1FFQUJDdVNadloxMDZJOUFLUVI0aERBUWpPUQ==",
    bulkSMSBody: null,
    messageCredit: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    schoolEmis: null,
    datePicker: new Date().toISOString().substr(0, 10),
    reportYear: new Date().getFullYear(),
    reportSource: "BitsEMS",
    reportYears: [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4
    ],
    showStudentFeeRecordAllYears:false,
    showDate: false,
    dialog: false,
    feeIDs: [],
    applyFee: false,
    categories: [],
    billStudents: false,
    viewStatement: false,
    academicReport: false,
    promoteStudents: false,
    bulkSMS: false,
    bulkDelete: false,
    edDescription: null,
    edAmount: null,
    blockReport: false,
    captureMarks: null,
    selectedFeeID: null,
    blockReportReason: "Contact Admin for Details",
    selectedStudentSid:null,
    selectAll: false,
    selectedClass: null,
    selectedTerm: null,
    selectedAdd: "manual",
    selectedFile: null,
    snackbarText: "",
    file64: null,
    snackbarColor: "",
    snackbarModel: false,
    lname: null,
    fname: null,
    grade: null,
    students: [],
    studentsIDData:[],
    studentFeeRecordByYears:[],
    studentFeeRecordByYearsHeaders:[
      
      {
        text: "SID",
        align: "start",
        value: "sid"
      },
      { text: "Year", value: "year" },
      { text: "Opening", value: "op_uf" },
      { text: "Fee ID", value: "fid" },
      { text: "Deposit", value: "deposit" },
      { text: "Monthly", value: "monthly" },
      { text: "Months", value: "months" },
      { text: "Starting Month", value: "starting_month" },
      { text: "Total Fees", value: "curfee" },
      { text: "Total Paid", value: "all_pay_sum" },
      { text: "Billings", value: "future_billings_unpaid_sum_by_year" },
      { text: "Total Due", value: "total_due_by_year" },
      { text: "Total Balance", value: "balance_due_year" },
    ],
    nameRules: [v => !!v || "Field is required"],
    showActionButtons: false,
    search: null,
    selectedStudents: [],
    allSelected: [],
    headers: [
      { text: "Profile", value: "profile" },
      {
        text: "SID",
        align: "start",
        value: "sid"
      },
      { text: "Surname", value: "lname" },
      { text: "Names", value: "fname" },
      { text: "Fee ID", value: "fid" },
      { text: "Opening", value: "financeInfo.op_uf" },
      { text: "Total Fees", value: "financeInfo.curfee" },
      { text: "Total Paid", value: "financeInfo.all_pay_sum" },
      { text: "Billings", value: "financeInfo.future_billings_unpaid_sum" },
      { text: "Total Due", value: "financeInfo.total_due" },
      { text: "Total Balance", value: "financeInfo.balance_due_year" },
    //   { text: "Jan", value: "dob" },
    //   { text: "Feb", value: "number_of_days_absent" },
    //   { text: "Mar", value: "number_of_days_absent" },
    //   { text: "Apr", value: "dob" },
    //   { text: "May", value: "number_of_days_absent" },
    //   { text: "Jun", value: "number_of_days_absent" },
    //   { text: "Jul", value: "dob" },
    //   { text: "Aug", value: "number_of_days_absent" },
    //   { text: "Sep", value: "number_of_days_absent" },
    //   { text: "Oct", value: "dob" },
    //   { text: "Nov", value: "number_of_days_absent" }

    ],
    terms: [
      { text: "Term 1", value: "term1" },
      { text: "Term 2", value: "term2" },
      { text: "Term 3", value: "term3" },
      { text: "Term 4", value: "term4" }
    ]
  }),
  methods: {
    getSelectedDate(selectedDate) {
      this.selectedDate = selectedDate;
      this.setSelectedClass(this.selectedClass);
    },
    selectAllStudents() {
      if (this.selectAll) {
        this.selectedStudents = [];
        this.students.forEach(student => {
          this.selectedStudents.push(student.sid);
        });
      } else {
        this.selectedStudents = [];
      }
    },
    billStudentsNow() {
      const students = this.selectedStudents;
      const amount = this.edAmount;
      const description = this.edDescription;
      const selectedDate = this.selectedDate;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bill-students-now",
          { students, amount, description, selectedDate },
          this.getAccessToken
        )
        .then(response => {
          if (response == "success") {
            this.$store.commit("setLoader", false);
            this.closeDialog();
            this.snackbarText = "Students Successfully Billed!";
            this.snackbarColor = "success";
            this.snackbarModel = true;
          }
        });
    },
    setSelectedClass(selectedClass) {
      this.selectedClass = selectedClass;
      this.showDate = true
      this.showStudentFeeRecordAllYears = false;
      this.$store.commit("setSelectedClass", selectedClass);

        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/get-students-for-selected-class",
            { selectedClass,feesSpreadsheet:'yes',selectedDate:this.selectedDate },
            this.getAccessToken
          )
          .then(studentsData => {
              
            this.$store.commit("setLoader", false);
            this.students = studentsData[0];
            studentsData[1].forEach(student => {
                this.studentsIDData.push({text:`${student.lname} ${student.fname} [${student.sid}] `,value:student.sid})
            })
            this.selectedStudents = [];
          });
      
    },
    getStudentFeeRecordAllYears(){
        this.$store.commit('setLoader',true)
        axios.postDataWithToken('/auth/get-student-fee-record-all-years',{
            selectedStudentSid:this.selectedStudentSid
        },this.getAccessToken).then(studentData => {
          
            this.showStudentFeeRecordAllYears = true
            this.studentFeeRecordByYears = studentData
            this.$store.commit('setLoader',false)
        })
    },
    uploadStudentsData() {
      const fileArr = this.selectedFile.name.split(".");
      const ext = fileArr[fileArr.length - 1];
      axios
        .postDataWithToken(
          "/auth/import-students",
          { file64: this.file64, template: this.selectedAdd, ext: ext },
          this.getAccessToken
        )
        .then(studentsData => {
          this.selectedAdd = null;
          this.snackbarText = "Students Successfully Added!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
          this.students.unshift(studentsData);
          this.selectedStudents = [];
        });
    },
    getSelections() {
      //console.log(this.selectedStudents);
    },
    openApplyFeeDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.applyFee = true;
      }
    },
    openViewStatementDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.viewStatement = true;
      }
    },
    openBulkDeleteDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.bulkDelete = true;
      }
    },
    openBillStudentsDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.billStudents = true;
        this.$store.commit("setLoader", true);
        axios
          .getData("/auth/get-all-income-categories", this.getAccessToken)
          .then(categories => {
            this.$store.commit("setLoader", false);
            this.categories = categories;
          });
      }
    },
    openBlockReportDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.blockReport = true;
      }
    },
    openAcademicReportDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.academicReport = true;
      }
    },
    openCaptureMarksDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.captureMarks = true;
      }
    },
    openPromoteStudentsDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.promoteStudents = true;
      }
    },
    openBulkSMSDialog() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.$store.commit("setLoader", true);
        axios
          .getData("/auth/get-messages-credit", this.getAccessToken)
          .then(credit => {
            this.messageCredit = credit;
            this.$store.commit("setLoader", false);
          });
        this.dialog = true;
        this.bulkSMS = true;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.applyFee = false;
      this.billStudents = false;
      this.blockReport = false;
      this.selectedStudents = [];
      this.edDescription = null;
      this.edAmount = null;
      this.viewStatement = false;
      this.academicReport = false;
      this.promoteStudents = false;
      this.bulkDelete = false;
      this.bulkSMS = false;
      this.captureMarks = false;
    },
    updateField(id, column) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "students", id, column, value },
          this.getAccessToken
        )
        .then(response => {
          const nothing = response;
        });
    },
    applyFeeIDNow() {
      const students = this.selectedStudents;
      const fid = this.selectedFeeID;
      const cls = this.selectedClass;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/apply-fee-ids-selection",
          { students, fid, cls },
          this.getAccessToken
        )
        .then(studentsData => {
          this.$store.commit("setLoader", false);
          this.students = studentsData;
          this.closeDialog();
          this.snackbarText = "Fee IDs Successfully Applied!";
          this.snackbarColor = "success";
          this.snackbarModel = true;
        });
    },
    sendBulkSMSNow() {
      const bulkSMSBody = this.bulkSMSBody;
      const students = this.selectedStudents;
      if (this.selectedStudents.length > 0 && bulkSMSBody != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/send-bulk-sms",
            { bulkSMSBody, students },
            this.getAccessToken
          )
          .then(messages => {
            if (messages == "none-sent") {
              this.$store.commit("setLoader", false);
              this.snackbarText = "Zero Messages Sent!";
              this.snackbarColor = "error";
              this.snackbarModel = true;
              this.closeDialog();
              return true;
            }
            if (messages.length && messages.length > 0) {
              axios
                .postDataWithToken(
                  "/auth/update-messages-table-with-sent-messages",
                  { messages, origin: "manage-students" },
                  this.getAccessToken
                )
                .then(response => {
                  if (response == "success") {
                    this.$store.commit("setLoader", false);
                    this.snackbarText = "Messages Successfully Sent!";
                    this.snackbarColor = "success";
                    this.snackbarModel = true;
                    this.closeDialog();
                  }
                });
            } else {
              this.$store.commit("setLoader", false);
              this.snackbarText = messages.detail;
              this.snackbarColor = "red";
              this.snackbarModel = true;
              this.closeDialog();
            }
          });
      } else {
        alert("Message Body Field is Required!");
        event.preventDefault();
      }
    },
    blockReportNow() {
      const reason = this.blockReportReason;
      const term = this.selectedTerm;
      const students = this.selectedStudents;
      if (term != null && reason != "" && students.length > 0) {
        axios
          .postDataWithToken(
            "/auth/block-reports",
            { reason, term, students },
            this.getAccessToken
          )
          .then(response => {
            this.closeDialog();
            this.snackbarText = "Selected Reports Successfully Blocked!";
            this.snackbarColor = "success";
            this.snackbarModel = true;
          });
      }
    },
    viewProfile(item) {
      this.$router.push({ name: "student-profile", params: { sid: item.sid } });
    },
    viewStudentsStatements() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
        return;
      }

      this.$router.push({
        name: "students-statements",
        params: {
          selectedStudents: this.selectedStudents,
          statementsDate: this.datePicker
        }
      });
    },
    exportMarksList() {
      if (this.selectedStudents.length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/get-selected-students",
            { selectedStudents: this.selectedStudents },
            this.getAccessToken
          )
          .then(selectedStudents => {
            const students = [];
            selectedStudents.forEach(student => {
              students.push({
                Class: student.class,
                SID: student.sid,
                Surname: student.lname,
                Names: student.fname,
                Cloumn1: "",
                Cloumn2: "",
                Cloumn3: "",
                Cloumn4: "",
                Cloumn5: ""
              });
            });

            const data = XLSX.utils.json_to_sheet(students);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, "data");
            XLSX.writeFile(wb, "BitsEMS_Class_List.xlsx");
            this.$store.commit("setLoader", false);
          });
      }
    },
    exportStudentsData() {
      const data = XLSX.utils.json_to_sheet(this.students);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "BitsEMS_Class_List.xlsx");
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/bulk-delete-students",
          {
            table: "students",
            sids: this.selectedStudents,
            selectedClass: this.selectedClass
          },
          this.getAccessToken
        )
        .then(students => {
          this.selectedStudents = [];
          this.snackbarText = "Selected Students Successfully Deleted!";
          this.snackbarColor = "success";
          this.students = students;
          this.$store.commit("setLoader", false);
          this.closeDialog();
          this.snackbarModel = true;
        });
    },
    getCardedStudents() {
      axios
        .getData("/auth/get-card-status-all", this.getAccessToken)
        .then(sids => {
          this.cardedStudents = sids;
        });
    },
    getReportBlocked() {
      axios
        .getData("/auth/get-blocked-reports-all", this.getAccessToken)
        .then(sids => {
          this.blockedReportStudents = sids;
        });
    },
    isCarded(sid) {
      return this.cardedStudents.includes(sid);
    },
    isReportBlocked(sid) {
      return this.blockedReportStudents.includes(sid);
    }
  }
};
</script>

<style>
</style>